var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvalidUrlGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 219,
    viewBox: "0 0 174 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2042 43.6464V53.3778",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5591 28.5358C17.5591 28.5358 10.3495 22.4438 7.57654 26.0041C5.0413 29.2479 10.5079 33.2037 17.5591 30.7511C17.5591 30.7511 6.38815 33.1246 8.3688 36.6849C10.5079 40.6408 17.5591 33.362 17.5591 33.362V28.5358Z",
    fill: "#F6C84A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1391 25.2138C40.1391 25.2138 46.1603 19.4382 48.5371 17.4603C52.4984 14.0582 59.1534 18.1723 53.766 24.9764C50.0423 29.6444 45.2888 34.7079 39.1883 39.6923C36.6531 41.7493 33.7217 43.4108 30.2358 43.4108C23.2639 43.4108 17.5596 37.7143 17.5596 30.752C17.5596 23.7897 23.2639 18.0932 30.2358 18.0932C32.5333 18.0932 34.6724 18.7262 36.4947 19.7547C36.4947 19.7547 40.7729 14.1373 44.655 15.245C47.1902 15.957 46.6356 19.1217 46.6356 19.1217",
    fill: "#FC9EC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9972 38.6643C34.3728 38.6643 37.9198 35.1221 37.9198 30.7526C37.9198 26.383 34.3728 22.8408 29.9972 22.8408C25.6217 22.8408 22.0746 26.383 22.0746 30.7526C22.0746 35.1221 25.6217 38.6643 29.9972 38.6643Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1391 25.2138C40.1391 25.2138 46.1603 19.4382 48.5371 17.4603C52.4984 14.0582 59.1534 18.1723 53.766 24.9764C50.0423 29.6444 45.2888 34.7079 39.1883 39.6923C36.6531 41.7493 33.7217 43.4108 30.2358 43.4108C23.2639 43.4108 17.5596 37.7143 17.5596 30.752C17.5596 23.7897 23.2639 18.0932 30.2358 18.0932C32.5333 18.0932 34.6724 18.7262 36.4947 19.7547C36.4947 19.7547 40.7729 14.1373 44.655 15.245C47.1902 15.957 46.6356 19.1217 46.6356 19.1217",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5591 28.5358C17.5591 28.5358 10.3495 22.4438 7.57654 26.0041C5.0413 29.2479 10.5079 33.2037 17.5591 30.7511C17.5591 30.7511 6.38815 33.1246 8.3688 36.6849C10.5079 40.6408 17.5591 33.362 17.5591 33.362V28.5358Z",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9972 38.6643C34.3728 38.6643 37.9198 35.1221 37.9198 30.7526C37.9198 26.383 34.3728 22.8408 29.9972 22.8408C25.6217 22.8408 22.0746 26.383 22.0746 30.7526C22.0746 35.1221 25.6217 38.6643 29.9972 38.6643Z",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7383 26.5579C23.5799 26.5579 23.4214 26.5579 23.263 26.5579C22.5499 27.7446 22.0746 29.1687 22.0746 30.7511C22.0746 35.1025 25.6398 38.6628 29.9972 38.6628C30.1557 38.6628 30.3141 38.6628 30.4726 38.6628C31.1856 37.4761 31.661 36.052 31.661 34.4696C31.661 30.1181 28.0958 26.5579 23.7383 26.5579Z",
    fill: "#5E6574"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7209 43.2526V52.5884",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.218 72.9185L168.484 91.1946L173 103.141L166.899 113.822L130.455 118.332",
    fill: "#CFEDF8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 93.3302C162.78 98.8684 150.658 104.565 130.376 98.9475L130.455 118.252L166.82 113.742L172.921 103.141L169.276 93.3302Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.989 37.6327L19.7766 54.8012L1 78.1408L22.9457 96.2587L124.355 90.404",
    fill: "#CFEDF8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2295 92.8556C55.8247 92.8556 60.4198 92.6973 65.0149 92.5391C72.6999 92.3018 79.9887 91.7479 87.436 90.3238C89.0997 86.8427 90.0504 82.8868 90.0504 78.7727C90.0504 63.7404 77.8496 51.5563 62.7966 51.5563C47.7436 51.5563 35.5427 63.7404 35.5427 78.7727C35.5427 84.0735 37.048 89.0579 39.7417 93.2512C43.5446 92.5391 47.4267 92.8556 51.2295 92.8556Z",
    fill: "#FAECC8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5354 89.0564C57.9634 91.1135 67.8666 90.797 77.5322 89.3729C79.909 86.2873 81.2559 82.4106 81.2559 78.2173C81.2559 68.0112 72.9371 59.7039 62.7169 59.7039C52.4967 59.7039 44.178 68.0112 44.178 78.2173C44.178 82.1732 45.4456 85.8917 47.5847 88.8982C47.9808 88.9773 48.2977 88.9773 48.5354 89.0564Z",
    fill: "#FADE92"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0323 85.1025C10.0323 85.1025 25.4815 71.257 42.0398 75.292C54.6368 78.3776 59.0734 85.4981 59.0734 85.4981C59.0734 85.4981 72.7004 73.2349 86.9611 74.659C101.222 76.004 100.192 86.5266 101.935 86.2102C101.935 86.2102 119.998 76.7161 124.752 86.9222L124.435 90.5616L23.1047 96.4163L10.0323 85.1025Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.593 210.524V18.4053H130.139V210.661",
    fill: "#DADADD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.593 210.524V18.4053H130.139V210.661",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.683 20.9376C133.196 20.9376 137.665 16.4744 137.665 10.9688C137.665 5.46318 133.196 1 127.683 1C122.17 1 117.7 5.46318 117.7 10.9688C117.7 16.4744 122.17 20.9376 127.683 20.9376Z",
    fill: "#DADADD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 10.9688C117.7 12.3138 118.017 13.6588 118.493 14.8456C119.364 15.0829 120.236 15.2411 121.186 15.2411C126.653 15.2411 131.169 10.8106 131.169 5.27234C131.169 3.92734 130.852 2.58235 130.377 1.39559C129.505 1.15823 128.634 1 127.683 1C122.216 1 117.7 5.43058 117.7 10.9688Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.683 20.9376C133.196 20.9376 137.665 16.4744 137.665 10.9688C137.665 5.46318 133.196 1 127.683 1C122.17 1 117.7 5.46318 117.7 10.9688C117.7 16.4744 122.17 20.9376 127.683 20.9376Z",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.989 37.6327L19.7766 54.8012L1 78.1408L22.9457 96.2587L124.355 90.404",
    stroke: "#5E6574",
    strokeWidth: 1.36102,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.218 72.9185L168.484 91.1946L173 103.141L166.899 113.822L130.455 118.332",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M127.919 209.555C127.919 209.555 120.076 165.882 108.984 152.432C108.984 152.432 112.787 181.705 120.551 212.166",
    fill: "#00B894"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.919 209.555C127.919 209.555 120.155 167.386 107.796 149.268C107.796 149.268 112.787 180.915 120.551 211.375",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M121.978 211.06C121.978 211.06 117.145 186.375 86.8807 176.881C86.8807 176.881 110.094 197.452 112.946 214.541",
    fill: "#00B894"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M121.978 211.06C121.978 211.06 117.145 186.375 86.8807 176.881C86.8807 176.881 110.094 197.452 112.946 214.541",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M145.588 189.618L140.993 213.59L133.625 211.375C133.625 211.375 135.289 197.609 135.843 196.659C136.318 195.631 140.597 183.13 140.597 183.13L145.588 189.618Z",
    fill: "#00B894"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.704 211.376C133.704 211.376 135.843 189.064 142.736 179.808",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.618 186.294C146.618 186.294 141.469 203.621 141.073 213.59",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M146.618 186.295L142.736 179.808L140.755 183.684L145.113 191.042L146.618 186.295Z",
    fill: "#5E6574"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 179.807H150.42C150.42 179.807 153.906 190.172 150.975 200.773C150.975 200.773 148.044 182.972 142.735 179.807Z",
    fill: "#00B894"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 179.807H150.42C150.42 179.807 153.906 190.172 150.975 200.773C150.975 200.773 148.044 182.972 142.735 179.807Z",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.064 217.388C114.214 213.274 120.79 210.822 127.92 210.822C134.892 210.822 141.309 213.195 146.459 217.072",
    stroke: "#5E6574",
    strokeWidth: 1.59508,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidUrlGraphic);
export default __webpack_public_path__ + "static/media/InvalidURLGraphic.4f1332c4d749920db670534fee9f7a31.svg";
export { ForwardRef as ReactComponent };